var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex-justiify-center"},[_c('el-button',{attrs:{"size":"small","type":"primary"}},[_vm._v("Invite")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }